export default __webpack_public_path__ + "static/media/ic_eth_24.eff059b0.svg";